import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { resetPassword } from '../entidades/entidades.component';

@Injectable({
  providedIn: 'root'
})

export class ChangePasswordService {

  URL_InspeccionTotal = `${environment.URL_InspeccionTotal}`;

  constructor(private http: HttpClient) { }

  validateUniqueID(uniqueId: string): Observable<any> {
    return this.http.get(`${this.URL_InspeccionTotal}v1/password/validateUniqueId/${uniqueId}`)
  }

  postNewPassword(userData: resetPassword): Observable<any> {
    return this.http.post(`${this.URL_InspeccionTotal}v1/password/resetearPassword`, userData)
  }

}
